import { Tag } from '@cian/components';
import * as React from 'react';

import { IGeoStreetTag } from '../../../../state/tags/definitions/geo/street';
import { TagNew } from '../../TagNew';

import { tagThemeSmall } from '../../tag_theme';

export interface IGeoStreetTagItemProps {
  tag: IGeoStreetTag;
  withNewTag?: boolean;
  onDeleteClick(): void;
}

export const GeoStreetTagItem = (props: IGeoStreetTagItemProps) => {
  const TagComponent = React.useMemo(() => (props.withNewTag ? TagNew : Tag), [props.withNewTag]);

  return (
    <TagComponent onDeleteClick={props.onDeleteClick} tagStyles={tagThemeSmall}>
      {props.tag.text}
    </TagComponent>
  );
};
